export default __webpack_public_path__ + "static/FuturaStdMedium-bfa46e394deb18a663e9ad577ca0ce4a.woff2";